// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__OJ8jd","list":"PatternAutocomplete_list__2TAi5"};